/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moisture_PercentageInputs */

const en_moisture_percentage = /** @type {(inputs: Moisture_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moisture %`)
};

const es_moisture_percentage = /** @type {(inputs: Moisture_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de humedad`)
};

/**
* | output |
* | --- |
* | "Moisture %" |
*
* @param {Moisture_PercentageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const moisture_percentage = /** @type {((inputs?: Moisture_PercentageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moisture_PercentageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moisture_percentage(inputs)
	return es_moisture_percentage(inputs)
});